/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { ResponsiveModule } from 'ng2-responsive';
import { AppBackdropComponent } from './components/app_backdrop/app_backdrop.component';
import { FooterComponent } from '../layout/footer/footer.component';
import { CdkTableModule } from '@angular/cdk/table';
import { FilemanagerComponent } from './components/filemanager/filemanager.component';
import { MediaGalleryComponent } from './components/media-gallery/media-gallery.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { ExtrafieldsComponent } from './components/extrafields/extrafields.component';
import { FrameworkPhasesStagesComponent } from './components/framework-phases-stages/framework-phases-stages.component';
import { FrameworkKpiDataComponent } from './components/framework-kpi-data/framework-kpi-data.component';
import { FileuploaderComponent } from './components/fileuploader/fileuploader.component';
import { FrameworkGroupComponent } from './components/framework-group/framework-group.component';
import { FrameworkGroupValuesComponent } from './components/framework-group-values/framework-group-values.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { DndModule } from 'ngx-drag-drop';
import { DndListComponent } from './components/drag-and-drop/dnd-list.component';
import { FlexLayoutModule} from '@angular/flex-layout';
import { StakeholderGroupComponent } from './components/stakeholder-group/stakeholder-group.component';
import { EscalationPolicyComponent } from 'app/shared/components/escalation-policy/escalation-policy.component';
import { ValueValidationComponent } from './components/value-validation/value-validation.component';
import { IndustryComponent } from './components/industry/industry.component';
import { ChartsModule } from 'ng2-charts';
import { ArrayFieldsComponent } from './components/array-fields/array-fields.component';
import { UserPermissionsComponent } from './components/user-permissions/user-permissions.component';
import { OktaAuthModule } from '@okta/okta-angular';
import { MetadataComponent } from './components/metadata/metadata.component';

@NgModule({
  imports: [
    FileUploadModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ResponsiveModule,
    MatSidenavModule,
    MatRippleModule,
    MatButtonModule,
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    DatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    OktaAuthModule,
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    FlexLayoutModule,
    DndModule,
    ChartsModule,
  ],
  declarations: [
    AppBackdropComponent,
    FooterComponent,
    FilemanagerComponent,
    MediaGalleryComponent,
    AvatarComponent,
    ExtrafieldsComponent,
    ArrayFieldsComponent,
    FrameworkPhasesStagesComponent,
    FrameworkKpiDataComponent,
    FrameworkGroupComponent,
    FrameworkGroupValuesComponent,
    AutocompleteComponent,
    UserPermissionsComponent,
    StakeholderGroupComponent,
    EscalationPolicyComponent,
    DndListComponent,
    FileuploaderComponent,
    ValueValidationComponent,
    IndustryComponent,
    MetadataComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ResponsiveModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    AppBackdropComponent,
    FooterComponent,
    ReactiveFormsModule,
    AlertModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    DatepickerModule,
    BsDropdownModule,
    ModalModule,
    PaginationModule,
    ProgressbarModule,
    RatingModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    TypeaheadModule,
    FilemanagerComponent,
    MediaGalleryComponent,
    AvatarComponent,
    ExtrafieldsComponent,
    ArrayFieldsComponent,
    FileuploaderComponent,
    FrameworkGroupComponent,
    FrameworkGroupValuesComponent,
    StakeholderGroupComponent,
    EscalationPolicyComponent,
    FrameworkPhasesStagesComponent,
    AutocompleteComponent,
    UserPermissionsComponent,
    FrameworkKpiDataComponent,
    DndListComponent,
    ValueValidationComponent,
    IndustryComponent,
    MetadataComponent,
    ChartsModule,
  ]
})

export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule
    };
  }
}
